import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { SofaPanel } from '@sofology/sofologycomponents';
import { Loader } from 'components';
import { AppState } from 'store';
import { generateDispatchToPropsMap } from 'helpers';
import { addToCartFromUrl, addToCartFromUrlFunc } from 'store/basket/actions';
import { routes } from 'routes';

import './AddToCartPage.scss';

interface StateProps {
    isAddingToBasketFromUrlProcessing: boolean;
}

interface DispatchProps {
    addToCartFromUrl: addToCartFromUrlFunc;
}

class AddToCartPage extends Component<StateProps & DispatchProps & RouteComponentProps> {

    componentDidMount() {
        this.props.addToCartFromUrl(this.props.location.search);
    }

    componentDidUpdate(prevProps: StateProps) {
        if (prevProps.isAddingToBasketFromUrlProcessing && !this.props.isAddingToBasketFromUrlProcessing) {
            this.props.history.push(routes.basket.path);
        }
    }

    render(): JSX.Element {
        return (
            <div className='add-to-cart-page'>
                {this.renderProcessing()}
            </div>
        );
    }

    renderProcessing(): JSX.Element {
        return (
            <div className='add-to-cart-page__processing'>
                <div className='add-to-cart-page__overlay'></div>
                <SofaPanel>
                    <div>Adding items from Room Planner to your basket. Please do not leave the page.</div>
                </SofaPanel>
                <Loader show={true} />

            </div>
        );
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        isAddingToBasketFromUrlProcessing: state.basketState.isAddingToCartFromUrlProcessing
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [addToCartFromUrl]);
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToCartPage);
